export class UserModel {
  uuid: string;
  email: string;
}
